import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Analytics, layoutActions } from '@Techedge/digitalportal-shared'
import Header from '../components/Layout/Header/Header'
import Sidebar from '../components/Layout/Sidebar/SideBar'
import MainContent from '../components/Layout/MainContent/MainContent'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '../redux/reducers/activity-creation'
import { LuxBreadcrumb } from '@lux/wardrobe-lib'
import StepBar from '../components/ActivityCreation/StepBar/StepBar'
import { NewActivitySectionType } from '../models/new-activity-section-type'
import { getDepartments, getFiltersDomain, getRecipients } from '../redux/actions/filters'
import { ProjectsService } from '../services/ProjectsService'
import { resetAllForm } from '../redux/actions/activity-creation'
import { ProjectApiCreateActivityBody } from '../models/projects-service'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '../redux/reducers/activity-execution'
import { creationAnalyticsPageTypeMap } from '../models/analyticsPageTypeMap'
import NewActivitySurveyTask from '../components/ActivityCreation/SurveyTask/NewActivitySurveyTask'
import './NewSurveyTask.scss'

const NewSurveyTask = (props) => {
    const {
        closeNewActivity,
        closeEditActivity,
        surveyTaskActivity,
        ctaTemplate,
        getDepartments,
        getRecipients,
        getFiltersDomain,
        projectId,
        setLoading,
        isEdit,
        projectDetailsStored,
        visitProps,
        storeId,
    } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-activity'

    const stepList = [
        {
            label: 'modals.new.activity.section.activity.type',
            isDone: true,
        },
        surveyTaskActivity.sectionMap[NewActivitySectionType.MAIN_INFO],
        surveyTaskActivity.sectionMap[NewActivitySectionType.ACTION],
        surveyTaskActivity.sectionMap[NewActivitySectionType.SCHEDULING],
    ]

    const [projectDetails, setProjectDetails] =
        useState<ProjectApiCreateActivityBody>(projectDetailsStored)

    const activityBreadcrumb = {
        id: '0',
        label: intl.formatMessage({
            id: 'modals.new.activity.breadcrumbs.activity',
            defaultMessage: 'Activity',
        }),
        className: 'activity selectable force-opacity-1',
        disabled: true,
    }

    const createBreadcrumb = {
        id: '1',
        label: intl.formatMessage({
            id: 'modals.new.activity.breadcrumbs.create',
            defaultMessage: 'Create',
        }),
        disabled: true,
    }

    useEffect(() => {
        if (!projectDetails || !projectDetails._id) {
            Analytics._sendAnalyticsLinkEvent('Activities', 'CreationPage', 'Static')
        }
        if (projectDetails && projectDetails._id && isEdit) {
            Analytics._sendAnalyticsLinkEvent(
                'Activities',
                creationAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                    .edit,
                'Static'
            )
        }
        getDepartments()
        getRecipients()
        getFiltersDomain()

        const activityBreadcrumbClick = () => {
            resetAllForm()
            if (isEdit) {
                closeEditActivity()
                return
            }
            closeNewActivity()
        }
        let activityBreadcrumbSelector = document.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.activity'
        )
        activityBreadcrumbSelector.addEventListener('click', activityBreadcrumbClick)

        if (projectId) {
            setLoading(true)
            ProjectsService.GetProjectDetails(projectId, [storeId])
                .then((res) => {
                    if (res && res.data) {
                        setProjectDetails({
                            ...res.data,
                            status: res.data.status,
                        })
                    }
                })
                .finally(() => setLoading(false))
        }
        return () => {
            activityBreadcrumbSelector.removeEventListener('click', activityBreadcrumbClick)
        }
    }, [])

    const onClose = () => {
        setProjectDetails(null)
        resetAllForm()
        if (isEdit) {
            closeEditActivity()
            return
        }
        closeNewActivity()
    }

    return (
        <div className="smart-modals-fullscreen smart-modals-new-survey-task">
            <div className={`${componentClass} smart-modals-new-survey-task`} data-isfullscreen>
                <div className={`${componentClass}__header`}>
                    <Header onClose={onClose} isFullScreen>
                        <LuxBreadcrumb pathArray={[activityBreadcrumb, createBreadcrumb]} />
                        <h1 className={`${componentClass}__header-mobile`}>
                            {intl.formatMessage({
                                id: 'modals.new.activity.news.create',
                                defaultMessage: 'Create new activity',
                            })}
                        </h1>
                    </Header>
                </div>
                <div className={`${componentClass}__main`}>
                    <div className={`${componentClass}__sidebar`}>
                        <Sidebar>
                            <StepBar stepList={stepList} />
                        </Sidebar>
                    </div>
                    <div className={`${componentClass}__content`}>
                        <MainContent footer={ctaTemplate}>
                            <NewActivitySurveyTask
                                projectDetails={projectDetails || null}
                                visitProps={visitProps}
                                closeNewActivity={closeNewActivity}
                            />
                        </MainContent>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    surveyTaskActivity: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].surveyTaskActivity,
    ctaConfig: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].ctaConfig,
    ctaTemplate: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].ctaTemplate,
    projectDetailsStored: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails,
    projectId: state.layoutReducer.modals.props?.id,
    storeId: state.layoutReducer.modals.props?.storeIdList,
    isEdit: state.layoutReducer.modals.props?.isEdit,
    visitProps: state.layoutReducer.modals.props,
})

const mapDispatchToProps = (dispatch: any) => ({
    closeEditActivity: () => {
        dispatch(resetAllForm())
        dispatch(
            layoutActions.setModals({
                type: null,
                props: { id: null, isEdit: false, isClone: false },
            })
        )
    },
    setLoading: (loading) => dispatch(layoutActions.setModals({ props: { loading } })),
    getDepartments: () => {
        dispatch(getDepartments())
    },
    getRecipients: () => {
        dispatch(getRecipients())
    },
    getFiltersDomain: () => {
        dispatch(getFiltersDomain())
    },
    resetAllForm: () => dispatch(resetAllForm()),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewSurveyTask)
